import React, { useState } from 'react'
import { 
  Checkbox,
  TableCell, 
  TableRow 
} from '@material-ui/core'

export const GruposLaboratorioItem = ({item, index}) => {
  const [checkbox, setCheckbox] = useState(false);

  const onChangeCheckboxHandler = (e) => {
    const checked = e.target.checked;

    setCheckbox(checked);
  };

  return (
    <TableRow>
      <TableCell style={{ width: "15%" }}>
        <Checkbox
          name={`grupo-${index}`}
          onChange={onChangeCheckboxHandler}
          checked={checkbox}
        />
      </TableCell>
      <TableCell style={{ width: "85%" }}>{item.nombre}</TableCell>
    </TableRow>
  )
}
